import { useState } from "react";
import { useParams } from "react-router-dom";
import { useAuth } from "../../../context/AuthContext";
import { useTournamentId, useTournamentSlug } from "../../../context/TournamentRouteContext";
import { tournamentPath } from "../../../utility/tournamentUrls";

export const useTeamEditState = () => {
  const { teamId } = useParams();
  const tournamentId = useTournamentId();
  const tournamentSlug = useTournamentSlug();
  const { user } = useAuth();

  // State
  const [loading, setLoading] = useState(true);
  const [team, setTeam] = useState(null);
  const [squads, setSquads] = useState([]);
  const [tournamentEvents, setTournamentEvents] = useState([]);
  const [formData, setFormData] = useState({
    bowlers: [],
  });

  // Breadcrumb items
  const breadcrumbItems = [
    { label: "Home", path: "/" },
    { label: "Tournaments", path: "/tournaments" },
    { label: "[Tournament Name]", path: tournamentPath(tournamentSlug) },
    { label: "Scoring", path: tournamentPath(tournamentSlug, `/scoring`) },
    { label: "Edit Team" },
  ];

  return {
    // Params
    tournamentId,
    teamId,
    user,

    // State
    loading,
    setLoading,
    team,
    setTeam,
    squads,
    setSquads,
    tournamentEvents,
    setTournamentEvents,
    formData,
    setFormData,

    // UI
    breadcrumbItems,
  };
};
